import { gsap } from 'gsap';

export default class ProcessAnimationSettings {
	constructor(elm) {
		this.elm = elm;

		this.slider1 = this.elm.querySelector('[data-process-animation-settings-slider1]');
		this.slider2 = this.elm.querySelector('[data-process-animation-settings-slider2]');
		this.slider3 = this.elm.querySelector('[data-process-animation-settings-slider3]');

		this.tl = gsap.timeline({
			repeat: -1,
			repeatDelay: 0,
		});

		this.tl.to(
			this.slider1,
			{
				'--slider-pos': '46%',
				duration: 2,
				ease: 'power2.inOut',
			},
			0
		);

		this.tl.to(
			this.slider2,
			{
				'--slider-pos': '85%',
				duration: 2,
				ease: 'power2.inOut',
			},
			2
		);

		this.tl.to(
			this.slider3,
			{
				'--slider-pos': '25%',
				duration: 2,
				ease: 'power2.inOut',
			},
			4
		);

		this.tl.to(
			this.slider1,
			{
				'--slider-pos': '33%',
				duration: 2,
				ease: 'power2.inOut',
			},
			6
		);

		this.tl.to(
			this.slider2,
			{
				'--slider-pos': '20%',
				duration: 2,
				ease: 'power2.inOut',
			},
			8
		);

		this.tl.to(
			this.slider3,
			{
				'--slider-pos': '65%',
				duration: 2,
				ease: 'power2.inOut',
			},
			10
		);
	}
}
